/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangePasswordInputBody,
  ErrorModel,
  ForgotPasswordInputBody,
  LoginInputBody,
  RegisterInputBody,
  ResetPasswordInputBody,
  SessionBody,
  UpdateMeInputBody,
  UserBody
} from '../model';

import { apiFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type authLoginResponse200 = {
  data: SessionBody
  status: 200
}

export type authLoginResponse401 = {
  data: ErrorModel
  status: 401
}

export type authLoginResponse422 = {
  data: ErrorModel
  status: 422
}

export type authLoginResponse429 = {
  data: ErrorModel
  status: 429
}

export type authLoginResponse500 = {
  data: ErrorModel
  status: 500
}

export type authLoginResponseSuccess = (authLoginResponse200) & {
  headers: Headers;
};
export type authLoginResponseError = (authLoginResponse401 | authLoginResponse422 | authLoginResponse429 | authLoginResponse500) & {
  headers: Headers;
};

export type authLoginResponse = (authLoginResponseSuccess | authLoginResponseError)

export const getAuthLoginUrl = () => {




  return `/auth/login`
}

/**
 * Отдаёт токен доступа в теле и токен обновления в cookie с флагом HttpOnly. Токен доступа хранить в памяти вкладки: положенный в localStorage, он доступен любому постороннему скрипту на странице. После десяти неудач подряд по адресу (или пятидесяти с одного IP) вход закрывается на четверть часа.
 * @summary Вход по почте и паролю
 */
export const authLogin = async (loginInputBody: NonReadonly<LoginInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<authLoginResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<authLoginResponse>(getAuthLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginInputBody)
  }
);}





export const getAuthLoginQueryKey = (loginInputBody?: NonReadonly<LoginInputBody>,) => {
    return [
    'POST', `/auth/login`, loginInputBody
    ] as const;
    }


export const getAuthLoginQueryOptions = <TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(loginInputBody: NonReadonly<LoginInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthLoginQueryKey(loginInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authLogin>>> = ({ signal }) => authLogin(loginInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthLoginQueryResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
export type AuthLoginQueryError = ErrorModel


export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogin>>,
          TError,
          Awaited<ReturnType<typeof authLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogin>>,
          TError,
          Awaited<ReturnType<typeof authLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вход по почте и паролю
 */

export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthLoginQueryOptions(loginInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authLogoutResponse204 = {
  data: void
  status: 204
}

export type authLogoutResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 204>
}

export type authLogoutResponseSuccess = (authLogoutResponse204) & {
  headers: Headers;
};
export type authLogoutResponseError = (authLogoutResponseDefault) & {
  headers: Headers;
};

export type authLogoutResponse = (authLogoutResponseSuccess | authLogoutResponseError)

export const getAuthLogoutUrl = () => {




  return `/auth/logout`
}

/**
 * Закрывает текущий сеанс и гасит cookie. Повторный выход тоже отвечает 204.
 * @summary Выйти
 */
export const authLogout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<authLogoutResponse> => {

  return apiFetch<authLogoutResponse>(getAuthLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthLogoutQueryKey = () => {
    return [
    'POST', `/auth/logout`
    ] as const;
    }


export const getAuthLogoutQueryOptions = <TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthLogoutQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authLogout>>> = ({ signal }) => authLogout({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof authLogout>>>
export type AuthLogoutQueryError = ErrorModel


export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogout>>,
          TError,
          Awaited<ReturnType<typeof authLogout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogout>>,
          TError,
          Awaited<ReturnType<typeof authLogout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Выйти
 */

export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthLogoutQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authMeResponse200 = {
  data: UserBody
  status: 200
}

export type authMeResponse401 = {
  data: ErrorModel
  status: 401
}

export type authMeResponse500 = {
  data: ErrorModel
  status: 500
}

export type authMeResponseSuccess = (authMeResponse200) & {
  headers: Headers;
};
export type authMeResponseError = (authMeResponse401 | authMeResponse500) & {
  headers: Headers;
};

export type authMeResponse = (authMeResponseSuccess | authMeResponseError)

export const getAuthMeUrl = () => {




  return `/auth/me`
}

/**
 * Проверяет токен доступа и возвращает пользователя. Фронтенд зовёт её при загрузке, чтобы понять, жив ли сеанс.
 * @summary Кто выполняет запрос
 */
export const authMe = async ( options?: Parameters<typeof apiFetch>[1]): Promise<authMeResponse> => {

  return apiFetch<authMeResponse>(getAuthMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuthMeQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }


export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>
export type AuthMeQueryError = ErrorModel


export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Кто выполняет запрос
 */

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authUpdateMeResponse200 = {
  data: UserBody
  status: 200
}

export type authUpdateMeResponse401 = {
  data: ErrorModel
  status: 401
}

export type authUpdateMeResponse422 = {
  data: ErrorModel
  status: 422
}

export type authUpdateMeResponse500 = {
  data: ErrorModel
  status: 500
}

export type authUpdateMeResponseSuccess = (authUpdateMeResponse200) & {
  headers: Headers;
};
export type authUpdateMeResponseError = (authUpdateMeResponse401 | authUpdateMeResponse422 | authUpdateMeResponse500) & {
  headers: Headers;
};

export type authUpdateMeResponse = (authUpdateMeResponseSuccess | authUpdateMeResponseError)

export const getAuthUpdateMeUrl = () => {




  return `/auth/me`
}

/**
 * Пока только имя. Адрес почты — это логин, его смена потребует подтверждения и появится вместе с почтой.
 * @summary Изменить свой профиль
 */
export const authUpdateMe = async (updateMeInputBody: NonReadonly<UpdateMeInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<authUpdateMeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<authUpdateMeResponse>(getAuthUpdateMeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMeInputBody)
  }
);}





export const getAuthUpdateMeQueryKey = (updateMeInputBody?: NonReadonly<UpdateMeInputBody>,) => {
    return [
    'PATCH', `/auth/me`, updateMeInputBody
    ] as const;
    }


export const getAuthUpdateMeQueryOptions = <TData = Awaited<ReturnType<typeof authUpdateMe>>, TError = ErrorModel>(updateMeInputBody: NonReadonly<UpdateMeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthUpdateMeQueryKey(updateMeInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authUpdateMe>>> = ({ signal }) => authUpdateMe(updateMeInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthUpdateMeQueryResult = NonNullable<Awaited<ReturnType<typeof authUpdateMe>>>
export type AuthUpdateMeQueryError = ErrorModel


export function useAuthUpdateMe<TData = Awaited<ReturnType<typeof authUpdateMe>>, TError = ErrorModel>(
 updateMeInputBody: NonReadonly<UpdateMeInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authUpdateMe>>,
          TError,
          Awaited<ReturnType<typeof authUpdateMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthUpdateMe<TData = Awaited<ReturnType<typeof authUpdateMe>>, TError = ErrorModel>(
 updateMeInputBody: NonReadonly<UpdateMeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authUpdateMe>>,
          TError,
          Awaited<ReturnType<typeof authUpdateMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthUpdateMe<TData = Awaited<ReturnType<typeof authUpdateMe>>, TError = ErrorModel>(
 updateMeInputBody: NonReadonly<UpdateMeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить свой профиль
 */

export function useAuthUpdateMe<TData = Awaited<ReturnType<typeof authUpdateMe>>, TError = ErrorModel>(
 updateMeInputBody: NonReadonly<UpdateMeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthUpdateMeQueryOptions(updateMeInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authChangePasswordResponse204 = {
  data: void
  status: 204
}

export type authChangePasswordResponse401 = {
  data: ErrorModel
  status: 401
}

export type authChangePasswordResponse403 = {
  data: ErrorModel
  status: 403
}

export type authChangePasswordResponse422 = {
  data: ErrorModel
  status: 422
}

export type authChangePasswordResponse500 = {
  data: ErrorModel
  status: 500
}

export type authChangePasswordResponseSuccess = (authChangePasswordResponse204) & {
  headers: Headers;
};
export type authChangePasswordResponseError = (authChangePasswordResponse401 | authChangePasswordResponse403 | authChangePasswordResponse422 | authChangePasswordResponse500) & {
  headers: Headers;
};

export type authChangePasswordResponse = (authChangePasswordResponseSuccess | authChangePasswordResponseError)

export const getAuthChangePasswordUrl = () => {




  return `/auth/password`
}

/**
 * Требует текущий пароль. Все остальные сеансы пользователя закрываются — текущий остаётся: смена пароля не должна выглядеть как выход.
 * @summary Сменить свой пароль
 */
export const authChangePassword = async (changePasswordInputBody: NonReadonly<ChangePasswordInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<authChangePasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<authChangePasswordResponse>(getAuthChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changePasswordInputBody)
  }
);}





export const getAuthChangePasswordQueryKey = (changePasswordInputBody?: NonReadonly<ChangePasswordInputBody>,) => {
    return [
    'POST', `/auth/password`, changePasswordInputBody
    ] as const;
    }


export const getAuthChangePasswordQueryOptions = <TData = Awaited<ReturnType<typeof authChangePassword>>, TError = ErrorModel>(changePasswordInputBody: NonReadonly<ChangePasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authChangePassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthChangePasswordQueryKey(changePasswordInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authChangePassword>>> = ({ signal }) => authChangePassword(changePasswordInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authChangePassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthChangePasswordQueryResult = NonNullable<Awaited<ReturnType<typeof authChangePassword>>>
export type AuthChangePasswordQueryError = ErrorModel


export function useAuthChangePassword<TData = Awaited<ReturnType<typeof authChangePassword>>, TError = ErrorModel>(
 changePasswordInputBody: NonReadonly<ChangePasswordInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authChangePassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authChangePassword>>,
          TError,
          Awaited<ReturnType<typeof authChangePassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthChangePassword<TData = Awaited<ReturnType<typeof authChangePassword>>, TError = ErrorModel>(
 changePasswordInputBody: NonReadonly<ChangePasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authChangePassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authChangePassword>>,
          TError,
          Awaited<ReturnType<typeof authChangePassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthChangePassword<TData = Awaited<ReturnType<typeof authChangePassword>>, TError = ErrorModel>(
 changePasswordInputBody: NonReadonly<ChangePasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authChangePassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сменить свой пароль
 */

export function useAuthChangePassword<TData = Awaited<ReturnType<typeof authChangePassword>>, TError = ErrorModel>(
 changePasswordInputBody: NonReadonly<ChangePasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authChangePassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthChangePasswordQueryOptions(changePasswordInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authForgotPasswordResponse204 = {
  data: void
  status: 204
}

export type authForgotPasswordResponse422 = {
  data: ErrorModel
  status: 422
}

export type authForgotPasswordResponse429 = {
  data: ErrorModel
  status: 429
}

export type authForgotPasswordResponse500 = {
  data: ErrorModel
  status: 500
}

export type authForgotPasswordResponseSuccess = (authForgotPasswordResponse204) & {
  headers: Headers;
};
export type authForgotPasswordResponseError = (authForgotPasswordResponse422 | authForgotPasswordResponse429 | authForgotPasswordResponse500) & {
  headers: Headers;
};

export type authForgotPasswordResponse = (authForgotPasswordResponseSuccess | authForgotPasswordResponseError)

export const getAuthForgotPasswordUrl = () => {




  return `/auth/password/forgot`
}

/**
 * Всегда отвечает 204, есть такой адрес или нет. Письмо уходит, только если человек может войти. Не больше трёх писем в час на адрес.
 * @summary Прислать ссылку для сброса пароля
 */
export const authForgotPassword = async (forgotPasswordInputBody: NonReadonly<ForgotPasswordInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<authForgotPasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<authForgotPasswordResponse>(getAuthForgotPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(forgotPasswordInputBody)
  }
);}





export const getAuthForgotPasswordQueryKey = (forgotPasswordInputBody?: NonReadonly<ForgotPasswordInputBody>,) => {
    return [
    'POST', `/auth/password/forgot`, forgotPasswordInputBody
    ] as const;
    }


export const getAuthForgotPasswordQueryOptions = <TData = Awaited<ReturnType<typeof authForgotPassword>>, TError = ErrorModel>(forgotPasswordInputBody: NonReadonly<ForgotPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthForgotPasswordQueryKey(forgotPasswordInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authForgotPassword>>> = ({ signal }) => authForgotPassword(forgotPasswordInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthForgotPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof authForgotPassword>>>
export type AuthForgotPasswordQueryError = ErrorModel


export function useAuthForgotPassword<TData = Awaited<ReturnType<typeof authForgotPassword>>, TError = ErrorModel>(
 forgotPasswordInputBody: NonReadonly<ForgotPasswordInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authForgotPassword>>,
          TError,
          Awaited<ReturnType<typeof authForgotPassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthForgotPassword<TData = Awaited<ReturnType<typeof authForgotPassword>>, TError = ErrorModel>(
 forgotPasswordInputBody: NonReadonly<ForgotPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authForgotPassword>>,
          TError,
          Awaited<ReturnType<typeof authForgotPassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthForgotPassword<TData = Awaited<ReturnType<typeof authForgotPassword>>, TError = ErrorModel>(
 forgotPasswordInputBody: NonReadonly<ForgotPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Прислать ссылку для сброса пароля
 */

export function useAuthForgotPassword<TData = Awaited<ReturnType<typeof authForgotPassword>>, TError = ErrorModel>(
 forgotPasswordInputBody: NonReadonly<ForgotPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthForgotPasswordQueryOptions(forgotPasswordInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authResetPasswordResponse204 = {
  data: void
  status: 204
}

export type authResetPasswordResponse404 = {
  data: ErrorModel
  status: 404
}

export type authResetPasswordResponse422 = {
  data: ErrorModel
  status: 422
}

export type authResetPasswordResponse500 = {
  data: ErrorModel
  status: 500
}

export type authResetPasswordResponseSuccess = (authResetPasswordResponse204) & {
  headers: Headers;
};
export type authResetPasswordResponseError = (authResetPasswordResponse404 | authResetPasswordResponse422 | authResetPasswordResponse500) & {
  headers: Headers;
};

export type authResetPasswordResponse = (authResetPasswordResponseSuccess | authResetPasswordResponseError)

export const getAuthResetPasswordUrl = () => {




  return `/auth/password/reset`
}

/**
 * Токен одноразовый и живёт час. Все сеансы человека закрываются — войти заново с новым паролем.
 * @summary Задать новый пароль по ссылке из письма
 */
export const authResetPassword = async (resetPasswordInputBody: NonReadonly<ResetPasswordInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<authResetPasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<authResetPasswordResponse>(getAuthResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resetPasswordInputBody)
  }
);}





export const getAuthResetPasswordQueryKey = (resetPasswordInputBody?: NonReadonly<ResetPasswordInputBody>,) => {
    return [
    'POST', `/auth/password/reset`, resetPasswordInputBody
    ] as const;
    }


export const getAuthResetPasswordQueryOptions = <TData = Awaited<ReturnType<typeof authResetPassword>>, TError = ErrorModel>(resetPasswordInputBody: NonReadonly<ResetPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthResetPasswordQueryKey(resetPasswordInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authResetPassword>>> = ({ signal }) => authResetPassword(resetPasswordInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthResetPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof authResetPassword>>>
export type AuthResetPasswordQueryError = ErrorModel


export function useAuthResetPassword<TData = Awaited<ReturnType<typeof authResetPassword>>, TError = ErrorModel>(
 resetPasswordInputBody: NonReadonly<ResetPasswordInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authResetPassword>>,
          TError,
          Awaited<ReturnType<typeof authResetPassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthResetPassword<TData = Awaited<ReturnType<typeof authResetPassword>>, TError = ErrorModel>(
 resetPasswordInputBody: NonReadonly<ResetPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authResetPassword>>,
          TError,
          Awaited<ReturnType<typeof authResetPassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthResetPassword<TData = Awaited<ReturnType<typeof authResetPassword>>, TError = ErrorModel>(
 resetPasswordInputBody: NonReadonly<ResetPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Задать новый пароль по ссылке из письма
 */

export function useAuthResetPassword<TData = Awaited<ReturnType<typeof authResetPassword>>, TError = ErrorModel>(
 resetPasswordInputBody: NonReadonly<ResetPasswordInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthResetPasswordQueryOptions(resetPasswordInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authRefreshResponse200 = {
  data: SessionBody
  status: 200
}

export type authRefreshResponse401 = {
  data: ErrorModel
  status: 401
}

export type authRefreshResponse422 = {
  data: ErrorModel
  status: 422
}

export type authRefreshResponse500 = {
  data: ErrorModel
  status: 500
}

export type authRefreshResponseSuccess = (authRefreshResponse200) & {
  headers: Headers;
};
export type authRefreshResponseError = (authRefreshResponse401 | authRefreshResponse422 | authRefreshResponse500) & {
  headers: Headers;
};

export type authRefreshResponse = (authRefreshResponseSuccess | authRefreshResponseError)

export const getAuthRefreshUrl = () => {




  return `/auth/refresh`
}

/**
 * Меняет токен обновления из cookie на новую пару. Прежний токен при этом перестаёт работать: предъявленный повторно спустя минуту и позже, он считается украденным, и все сеансы пользователя закрываются. В первую минуту после смены прежний токен ещё принимается — так вторая вкладка того же браузера, обновившаяся одновременно с первой, получает свой сеанс, а не выход на всех устройствах.
 * @summary Обновить доступ
 */
export const authRefresh = async ( options?: Parameters<typeof apiFetch>[1]): Promise<authRefreshResponse> => {

  return apiFetch<authRefreshResponse>(getAuthRefreshUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthRefreshQueryKey = () => {
    return [
    'POST', `/auth/refresh`
    ] as const;
    }


export const getAuthRefreshQueryOptions = <TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthRefreshQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authRefresh>>> = ({ signal }) => authRefresh({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthRefreshQueryResult = NonNullable<Awaited<ReturnType<typeof authRefresh>>>
export type AuthRefreshQueryError = ErrorModel


export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRefresh>>,
          TError,
          Awaited<ReturnType<typeof authRefresh>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRefresh>>,
          TError,
          Awaited<ReturnType<typeof authRefresh>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Обновить доступ
 */

export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthRefreshQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authRegisterResponse201 = {
  data: SessionBody
  status: 201
}

export type authRegisterResponse403 = {
  data: ErrorModel
  status: 403
}

export type authRegisterResponse409 = {
  data: ErrorModel
  status: 409
}

export type authRegisterResponse422 = {
  data: ErrorModel
  status: 422
}

export type authRegisterResponse429 = {
  data: ErrorModel
  status: 429
}

export type authRegisterResponse500 = {
  data: ErrorModel
  status: 500
}

export type authRegisterResponseSuccess = (authRegisterResponse201) & {
  headers: Headers;
};
export type authRegisterResponseError = (authRegisterResponse403 | authRegisterResponse409 | authRegisterResponse422 | authRegisterResponse429 | authRegisterResponse500) & {
  headers: Headers;
};

export type authRegisterResponse = (authRegisterResponseSuccess | authRegisterResponseError)

export const getAuthRegisterUrl = () => {




  return `/auth/register`
}

/**
 * Заводит учётную запись и сразу входит — тот же ответ, что у входа. Пространств у нового человека нет: его находят по адресу и приглашают. Занятый адрес — 409. С одного IP — не больше пятидесяти попыток за четверть часа, как у входа.
 * @summary Регистрация
 */
export const authRegister = async (registerInputBody: NonReadonly<RegisterInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<authRegisterResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<authRegisterResponse>(getAuthRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(registerInputBody)
  }
);}





export const getAuthRegisterQueryKey = (registerInputBody?: NonReadonly<RegisterInputBody>,) => {
    return [
    'POST', `/auth/register`, registerInputBody
    ] as const;
    }


export const getAuthRegisterQueryOptions = <TData = Awaited<ReturnType<typeof authRegister>>, TError = ErrorModel>(registerInputBody: NonReadonly<RegisterInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegister>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthRegisterQueryKey(registerInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authRegister>>> = ({ signal }) => authRegister(registerInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authRegister>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof authRegister>>>
export type AuthRegisterQueryError = ErrorModel


export function useAuthRegister<TData = Awaited<ReturnType<typeof authRegister>>, TError = ErrorModel>(
 registerInputBody: NonReadonly<RegisterInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegister>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRegister>>,
          TError,
          Awaited<ReturnType<typeof authRegister>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthRegister<TData = Awaited<ReturnType<typeof authRegister>>, TError = ErrorModel>(
 registerInputBody: NonReadonly<RegisterInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegister>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRegister>>,
          TError,
          Awaited<ReturnType<typeof authRegister>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthRegister<TData = Awaited<ReturnType<typeof authRegister>>, TError = ErrorModel>(
 registerInputBody: NonReadonly<RegisterInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegister>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Регистрация
 */

export function useAuthRegister<TData = Awaited<ReturnType<typeof authRegister>>, TError = ErrorModel>(
 registerInputBody: NonReadonly<RegisterInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegister>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthRegisterQueryOptions(registerInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






